import Slider from './hammer-slider';
import { addLazyLoadCallback, lazyLoadInstance } from '../../submodules/src/script/common';

const isNodeDescendant = function (parent, child) {
    let node = child.parentNode;
    while (node != null) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
};

const LazySlider = function (sliderElementSelector) {
    let sliderEl,
        initSettings,
        initCallback,
        originalSliderInit,
        firstImgLoaded = false,
        reportImgLoad = true,
        canInit = false;

    sliderEl = document.querySelector(sliderElementSelector);

    addLazyLoadCallback((el) => {
        firstImgLoaded = firstImgLoaded || isNodeDescendant(sliderEl, el);
        if (firstImgLoaded) doInit();
    });

    const doInit = () => {
        if (!canInit) return;
        canInit = false;

        initSettings.lazyImages = true;

        const oldOnNavigateCallback = initSettings.onNavigate;

        initSettings.onNavigate = (slider, currentSlideIndex, slidesCount) => {
            if (reportImgLoad) {
                const imgLoadedInSlider = sliderEl.querySelector('.loaded');
                slider.onLazyImageLoad(imgLoadedInSlider);
                reportImgLoad = false;
            }
            lazyLoadInstance.update();
            if (oldOnNavigateCallback && typeof oldOnNavigateCallback === 'function')
                oldOnNavigateCallback(slider, currentSlideIndex, slidesCount);
        };

        originalSliderInit(initSettings, initCallback);
    };

    const slider = new Slider(sliderElementSelector);
    originalSliderInit = slider.init.bind(slider);
    slider.init = (settings, callback) => {
        canInit = true;
        initSettings = settings;
        initCallback = callback;
        if (firstImgLoaded) doInit();
    };

    return slider;
};

export default LazySlider;
